<template>
  <div class="notification" :class="displayType">
    <div class="h-section h-section--no-margin">
      <div class="notification__container">
        {{ item.text }}
        <button class="notification__close" v-if="item.dismissible" @click="dismiss">{{ $t('alert-close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_INFO, NOTIFICATION_TYPE_WARNING, NOTIFICATION_TYPE_ERROR } from '@/consts/enums'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visibility: true
    }
  },
  mounted() {
    if (this.item.duration !== -1) {
      this.timeout = setTimeout(this.dismiss, this.item.duration)
    }
  },
  computed: {
    displayType: function() {
      switch (this.item.type) {
        case NOTIFICATION_TYPE_SUCCESS: {
          return 'notification--success'
        }
        case NOTIFICATION_TYPE_WARNING: {
          return 'notification--warning'
        }
        case NOTIFICATION_TYPE_ERROR: {
          return 'notification--error'
        }
        case NOTIFICATION_TYPE_INFO:
        default: {
          return 'notification--info'
        }
      }
    }
  },
  methods: {
    dismiss: function() {
      clearTimeout(this.timeout)
      this.visibility = false
    }
  },
  watch: {
    visibility(val) {
      if (!val) {
        this.$emit('dismiss', this.item.id)
      }
    }
  }
}
</script>

<style lang="scss">
.notification {
  color: white;
  font-size: 18px;
  font-weight: 600;
  left: 0;
  padding: 12px 0;
  position: fixed;
  top: 0;
  text-align: center;
  width: 100%;
  z-index: 9999;

  &--warning {
    background-color: #e69e00;
  }

  &--error {
    background-color: #e00c05;
  }

  &--info {
    background-color: #2dc5cf;
  }

  &--success {
    background-color: #00c888;
  }

  &__container {
    position: relative;
  }

  &__close {
    appearance: none;
    background: transparent url(~@/assets/close.svg) no-repeat center center;
    background-size: contain;
    border: 0;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    font: 0/0 a;
    height: 15px;
    margin: auto;
    padding: 0;
    position: absolute;
    right: 0;
    text-shadow: none;
    top: 0;
    white-space: nowrap;
    width: 15px;
  }
}
</style>
